module.exports = __webpack_public_path__ + "img/wifiplus.e81fed1f.svg";